import { StateUpdater, useEffect, useState } from "preact/hooks";
import { quizAnswers } from "./qna-section";

const Timer = ({
  playQuiz,
  setTimerExpired,
  setPlayQuiz,
  resetTimer,
  setQuizAnswers,
  setCurrentIndex,
  timerDuration,
}: {
  playQuiz: boolean;
  resetTimer: boolean;
  setTimerExpired: StateUpdater<boolean>;
  setPlayQuiz: StateUpdater<boolean>;
  setQuizAnswers: StateUpdater<quizAnswers>;
  setCurrentIndex: StateUpdater<number>;
  timerDuration: number;
}) => {
  const [seconds, setSeconds] = useState(timerDuration);

  useEffect(() => {
    let interval: NodeJS.Timeout | undefined;
    if (resetTimer) {
      setSeconds(timerDuration);
      setQuizAnswers({});
      setCurrentIndex(0);
    }
    if (playQuiz) {
      interval = setInterval(() => {
        setSeconds((prevSeconds) => {
          if (prevSeconds === 0) {
            clearInterval(interval);
            setTimerExpired(true);
            setPlayQuiz(false);
            return 0;
          }
          return prevSeconds - 1;
        });
      }, 1000);
    }

    return () => {
      clearInterval(interval);
    };
  }, [playQuiz]);

  const formatTime = (time: number): string => {
    const minutes: number = Math.floor(time / 60);
    const seconds: number = time % 60;
    return `${minutes < 10 ? "0" : ""}${minutes}:${
      seconds < 10 ? "0" : ""
    }${seconds}`;
  };

  return (
    <div className="wor-text-3xl wor-font-semibold">{formatTime(seconds)}</div>
  );
};

export default Timer;
